<app-flights-search-flights></app-flights-search-flights>

<div class="modal-footer">
  <button class="btn btn-outline-secondary settings-modal-button" type="button" (click)="closeWindow.emit()">Cancel</button>
  <button class="btn button-blue settings-modal-button" type="button" (click)="addFlights()">Save</button>
</div>
